import { ThemeProvider } from '@emotion/react';
import { createTheme, CssBaseline } from '@mui/material';
import BrowserApp from './BrowserApp/BrowserApp';
import MediaQuery from 'react-responsive';
import MobileApp from './MobileApp/MobileApp';
import StructureData from './components/StructureData/StructureData';


const fykifykiMobileTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#ffffff',
    },
    secondary: {
      main: '#63b7c1',
    },
  },
});


const fykifykiBrowserTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#ffffff',
    },
    secondary: {
      main: '#6f6f6f',
    },
  },
});


// new #63B7C1
// old #6f6f6f

const MOBILE_WIDTH = 1224

function App() {
  return (
    <div className='App'>
      <StructureData />
      <MediaQuery minWidth={MOBILE_WIDTH}>
        <ThemeProvider theme={fykifykiBrowserTheme} >
          <CssBaseline />
          <BrowserApp />
        </ThemeProvider>
      </MediaQuery>
      <MediaQuery maxWidth={MOBILE_WIDTH}>
        <ThemeProvider theme={fykifykiMobileTheme} >
          <CssBaseline />
          <MobileApp />
        </ThemeProvider>
      </MediaQuery>  
    </div>
    
  );
}

export default App;

